import cities from "./cities"

export default {
  namespaced: true,
  modules: {
    cities
  }
}
